import React from "react";
import DashboardLayout from "../../components/DashboardLayout";
import { Package, FileText, Download, Star, User, MessageCircle } from "lucide-react";

export default function CustomerDashboardLayout() {
  return (
    <DashboardLayout
      title="Customer Dashboard"
      testIdPrefix="customer"
      links={[
        { to: "/dashboard", label: "My Orders", icon: Package, end: true },
        { to: "/dashboard/inbox", label: "Messages", icon: MessageCircle },
        { to: "/dashboard/downloads", label: "Downloads", icon: Download },
        { to: "/dashboard/reviews", label: "Reviews", icon: Star },
        { to: "/dashboard/account", label: "Account", icon: User },
      ]}
    />
  );
}
